import { Box, Stack } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { Outlet } from 'react-router-dom'

import { CampaignEditTabActionsSlotProvider } from '~/features/campaigns/components/ofuManageCampaign/campaignEditTabActionsSlot'
import CampaignPageNotFound from '~/features/campaigns/components/ofuManageCampaign/campaignPageNotFound'
import ManageCampaignTabs from '~/features/campaigns/components/ofuManageCampaign/manageCampaignTabs'
import OfuManageTopBar from '~/features/campaigns/components/ofuManageCampaign/ofuManageTopBar'
import useGetSelectedCampaign from '~/hooks/useGetSelectedCampaign'

function OfuManageCampaignContainer() {
  const theme = useTheme()
  const { isNotFound } = useGetSelectedCampaign()

  return (
    <CampaignEditTabActionsSlotProvider>
      <Stack
        direction="column"
        sx={{
          width: '100%',
          height: '100%',
          overflow: 'hidden',
        }}
      >
        {!isNotFound && (
          <Stack sx={{ flexShrink: 0 }}>
            <OfuManageTopBar />
            <ManageCampaignTabs />
          </Stack>
        )}

        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            overflow: 'auto',
            width: '100%',
            backgroundColor: theme.palette.mainBackground,
          }}
        >
          {isNotFound ? <CampaignPageNotFound /> : <Outlet />}
        </Box>
      </Stack>
    </CampaignEditTabActionsSlotProvider>
  )
}

export default OfuManageCampaignContainer
